import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© 2025 Abhi Murali</p>
    </footer>
  );
};

export default Footer;
